module.exports = __webpack_public_path__ + "img/ico-nuevo-servicio-w.538cf959.svg";